import { render, staticRenderFns } from "./ClickToCopy.vue?vue&type=template&id=0738c789&scoped=true&lang=pug"
import script from "./ClickToCopy.vue?vue&type=script&lang=js"
export * from "./ClickToCopy.vue?vue&type=script&lang=js"
import style0 from "./ClickToCopy.vue?vue&type=style&index=0&id=0738c789&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0738c789",
  null
  
)

export default component.exports